//libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import Button from '/react4xp/components/Button'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
export interface HeroBannerProps {
    src?: string
    srcMedium?: string
    alt?: string
    title?: string
    text?: string
    buttonText?: string
    href?: string
    hrefExternal?: boolean
    bgColor?: string
}

export default function HeroBanner({
    src,
    srcMedium,
    alt,
    title,
    text,
    buttonText,
    href,
    hrefExternal,
    bgColor
}: HeroBannerProps) {
    return (
        <Section
            bgColor={bgColor}
            marginTop='none'
        >
            <div className='container'>
                <div className='hero-banner'>
                    <div className='row'>

                        {isNonWhitespaceString(src) && (
                            <div className='col-md-6 col-left'>    
                                <div className='image'>
                                    <Image
                                        src={src} // 600px x 550px
                                        srcMedium={srcMedium} // 650px x 850px
                                        width={650} 
                                        alt={alt}
                                        sizes='
                                            (max-width: 768px) 100vw,
                                            50vw
                                        '
                                        className='cover'
                                    />
                                </div>
                            </div>
                        )}

                        <div className={clsx(
                            isNonWhitespaceString(src) ? 'col-md-6' : 'col-12',
                            'col-right'
                        )}>

                            {isNonWhitespaceString(title) && (
                                <h1 className='h1-hero line-break'>
                                    {title}
                                </h1>
                            )}

                            {isNonWhitespaceString(text) && (
                                <div
                                    className='h3'
                                    dangerouslySetInnerHTML={{ __html: text }}
                                    suppressHydrationWarning
                                />
                            )}

                            {isNonWhitespaceString(buttonText) && (
                                <Button
                                    href={href}
                                    isSolid
                                    noUnderline
                                    target={!!hrefExternal}
                                >
                                    {buttonText}
                                </Button>
                            )}

                        </div>

                    </div>
                </div>
            </div>
        </Section>
    )
}